
    import './styles.scoped.css';
    export default {
  "handle": "awsui_handle_19hnz_o00ov_9",
  "active": "awsui_active_19hnz_o00ov_16"
};
  